"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { SolutionsCardsCarouselProps } from "./types";
import SolutionsCard from "../SolutionsCard";

const SolutionsCardsCarousel = ({
  className,
  cards,
}: SolutionsCardsCarouselProps) => {
  return (
    <Carousel.Mobile
      options={{
        slides: {
          spacing: 24,
          perView: "auto",
        },
      }}
      showPagination
      className={cn(
        "md:!grid md:!grid-cols-3 md:!gap-4 !overflow-visible",
        className
      )}
    >
      {cards.map(({ iconId, title, description, href, linkLabel }, idx) => (
        <CarouselSlide
          key={idx}
          className="!min-w-[82%] !w-[82%] !md:min-w-auto !w-auto transition-opacity duration-300 will-change-[opacity] md:transition-none md:!opacity-100 md:duration-initial"
        >
          <SolutionsCard
            iconId={iconId}
            title={title}
            description={description}
            href={href}
            linkLabel={linkLabel}
          />
        </CarouselSlide>
      ))}
    </Carousel.Mobile>
  );
};

export default memo(SolutionsCardsCarousel);
